<div mat-dialog-title>
  <button mat-icon-button [mat-dialog-close] class="close">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <img #imgCartographie>
</div>